import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { featuresSelectors } from '../redux/modules/features';

export type Features = {
  [key: string]: boolean;
};

type HasFeaturesFunc = (...keys: any[]) => boolean;

// This hook relies on a Redux store to handle the actual fetching/updating/etc.
// ... it is literally just a runtime check for one or more flags to be TRUE.
export const useFeatures = (): HasFeaturesFunc => {
  const features = useSelector(featuresSelectors.selectFeatures);
  return useCallback(
    (...keys) => keys.every(key => features[key] === true),
    [features],
  );
};

export default useFeatures;
